import { apiClient } from './client';
import type { SuggestMealsRequest, SuggestMealsResponse } from '@/types/api';

export async function suggestMeals(
  data: SuggestMealsRequest,
  signal?: AbortSignal,
): Promise<SuggestMealsResponse> {
  const response = await apiClient.post<SuggestMealsResponse>(
    '/ai/suggest-meals',
    data,
    { signal },
  );
  return response.data;
}
